import { DutyRole } from "./DutyRole"

export interface CoreAzureAdGroupExport {
    groupSelection: AzureADExportGroupSelection
    groupType: AzureADExportGroupType
    schoolUnitRoleStaffGroupRoles: DutyRole[]
    ownerMembershipType: AzureADExportGroupMembershipType
    memberMembershipType: AzureADExportGroupMembershipType
    groupRoleNameLanguage: EntraIdGroupRoleNameLanguage
    removeAfter: number | null
    inactivateAfter: number | null
    id: string
    prefix?: string
    suffix?: string
    activityInformationMarkingFilters: string[]
}

enum AzureADExportGroupSelection {
    None = 0x0000,
    ExportSchoolStudentGroup = 0x0001,
    ExportSchoolStaffGroup = 0x0002,
    ExportSchoolGroups = 0x0004,
    ExportMentorGroups = 0x0008,
    ExportDepartmentGroup = 0x0010,
    ExportDepartmentStaffGroup = 0x0020,
    ExportDepartmentStudentGroup = 0x0040,
    ExportClassGroup = 0x0080,
    ExportClassStaffGroup = 0x0100,
    ExportClassStudentGroup = 0x0200,
    ExportEducationGroup = 0x0400,
    ExportEducationStaffGroup = 0x0800,
    ExportEducationStudentGroup = 0x1000,
}

export const AzureAdExportGroupSelectionOptions: AzureADExportGroupSelection[] = [
    AzureADExportGroupSelection.ExportSchoolGroups,
    AzureADExportGroupSelection.ExportSchoolStaffGroup,
    AzureADExportGroupSelection.ExportSchoolStudentGroup,
    AzureADExportGroupSelection.ExportMentorGroups,
    AzureADExportGroupSelection.ExportDepartmentGroup,
    AzureADExportGroupSelection.ExportDepartmentStaffGroup,
    AzureADExportGroupSelection.ExportDepartmentStudentGroup,
    AzureADExportGroupSelection.ExportClassGroup,
    AzureADExportGroupSelection.ExportClassStaffGroup,
    AzureADExportGroupSelection.ExportClassStudentGroup,
    AzureADExportGroupSelection.ExportEducationGroup,
    AzureADExportGroupSelection.ExportEducationStaffGroup,
    AzureADExportGroupSelection.ExportEducationStudentGroup
];

enum AzureADExportGroupType {
    Unknown = 0,
    Microsoft365 = 1,
    Security = 2,
}

export const AzureAdExportGroupTypeOptions: AzureADExportGroupType[] = [
    AzureADExportGroupType.Microsoft365,
    AzureADExportGroupType.Security
];
enum AzureADExportGroupMembershipType {
    Unknown = 0,
    Strict = 1,
    Permissive = 2
}

export const AzureAdGroupMembershipTypeOptions: AzureADExportGroupMembershipType[] = [
    AzureADExportGroupMembershipType.Strict,
    AzureADExportGroupMembershipType.Permissive
];

export enum EntraIdGroupRoleNameLanguage {
    Undefined = 0,
    Swedish = 1,
    English = 2,
}